import type { FC } from 'react';

interface LoyaltyProps {}

const Loyalty: FC<LoyaltyProps> = () => {
  return <div>loyalty</div>;
};

export default Loyalty;
